// Only what en-GB says differently; every other string is en-US (mergeLocaleResources).
export const sites = {
  kind: {
    type: {
      neighbourhood: 'Neighbourhood',
      distribution_centre: 'Distribution centre',
      data_centre: 'Data centre',
      shopping_centre: 'Shopping centre',
    },
  },
} as const;
